import { Controller } from "@hotwired/stimulus"

// Combines individual CCCT note fields into a single message for auto-save and submission.
export default class extends Controller {
  static targets = ["spokeToInput", "summaryInput", "notesInput", "nextStepsInput", "messageHidden",
    "helpNeededCheckbox", "helpTextarea", "helpBox", "spokeToError", "summaryError", "notesError", "nextStepsError", "helpNeededError"]
  static values = { taskTitle: String }

  connect() {
    this.form = this.element
    this.activeFetch = null
    this.toggleHelp()
  }

  toggleHelp() {
    if (!this.hasHelpNeededCheckboxTarget) return

    const checked = this.helpNeededCheckboxTarget.checked
    if (this.hasHelpBoxTarget) {
      this.helpBoxTarget.classList.toggle("hidden", !checked)
    }
  }

  composeMessage() {
    const spokeTo = this.spokeToInputTarget.value.trim()
    const summary = this.summaryInputTarget.value.trim()
    const notes = this.notesInputTarget.value.trim()
    const nextSteps = this.nextStepsInputTarget.value.trim()

    const parts = []
    if (this.taskTitleValue) parts.push(`#### ${this.taskTitleValue}`)
    if (spokeTo) parts.push(`#### Spoke To:\n${spokeTo}`)
    if (summary) parts.push(`#### Summary:\n${summary}`)
    if (notes) parts.push(`#### Notes:\n${notes}`)
    if (nextSteps) parts.push(`#### Next Steps:\n${nextSteps}`)

    if (this.hasHelpNeededCheckboxTarget && this.helpNeededCheckboxTarget.checked && this.hasHelpTextareaTarget) {
      const helpText = this.helpTextareaTarget.value.trim()
      if (helpText) parts.push(`#### Needed From Support:\n${helpText}`)
    }

    return parts.join("\n\n")
  }

  save(event) {
    this.messageHiddenTarget.value = this.composeMessage()

    if (rails_env == "development" && this.activeFetch != null) {
      return
    }

    this.mostRecentSave = event.timeStamp

    setTimeout(() => {
      if (this.mostRecentSave === event.timeStamp) {
        const formData = new FormData(this.form)

        this.activeFetch = fetch(this.form.action, {
          method: this.form.method,
          body: formData,
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            "Accept": "text/vnd.turbo-stream.html",
          }
        }).then(() => {
          this.activeFetch = null
        })
      }
    }, 1000)
  }

  validate(event) {
    let valid = true

    this.clearErrors()

    if (!this.spokeToInputTarget.value.trim()) {
      this.showError(this.spokeToErrorTarget, "Spoke to is required")
      valid = false
    }
    if (!this.summaryInputTarget.value.trim()) {
      this.showError(this.summaryErrorTarget, "Summary is required")
      valid = false
    }
    if (!this.notesInputTarget.value.trim()) {
      this.showError(this.notesErrorTarget, "Notes is required")
      valid = false
    }
    if (!this.nextStepsInputTarget.value.trim()) {
      this.showError(this.nextStepsErrorTarget, "Next steps is required")
      valid = false
    }
    if (this.hasHelpNeededCheckboxTarget && this.helpNeededCheckboxTarget.checked) {
      if (this.hasHelpTextareaTarget && !this.helpTextareaTarget.value.trim()) {
        this.showError(this.helpNeededErrorTarget, "Please describe what help is needed")
        valid = false
      }
    }

    if (!valid) {
      event.preventDefault()
      return
    }

    this.messageHiddenTarget.value = this.composeMessage()
  }

  clearErrors() {
    ;[this.spokeToErrorTarget, this.summaryErrorTarget, this.notesErrorTarget, this.nextStepsErrorTarget].forEach(el => {
      el.textContent = ""
      el.classList.add("hidden")
    })
    if (this.hasHelpNeededErrorTarget) {
      this.helpNeededErrorTarget.textContent = ""
      this.helpNeededErrorTarget.classList.add("hidden")
    }

  }

  showError(target, message) {
    target.textContent = message
    target.classList.remove("hidden")
  }
}
